import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { getIsClosed, getIsFiltered, getIsOpen, getIsSoftDeleted } from 'conversations-thread-data/thread-details/public/operators';
import { isBotConversationWithRecentMessages } from '../../reassignment/operators/isBotConversationWithRecentMessages';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ActionButton } from './ActionButton';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { DeleteIcon, RedoIcon, RotateIcon, SuccessIcon } from 'foundations-assets';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { getClickedModalCta } from '../../prompts/constants/Events';
// @ts-expect-error untyped
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import CloseConversationTourStep from './CloseConversationTourStep';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SHARED_ICON_PROPS = {
  paddingInline: '0',
  size: '300'
};
const ThreadPrimaryActions = ({
  isOpeningThread,
  threadDetails,
  disabled,
  openThread,
  closeThread,
  isClosingCurrentConversation,
  openDeletePrompt,
  restoreThread
}) => {
  const shouldShowOpenButton = getIsClosed(threadDetails) && !isClosingCurrentConversation;
  const shouldShowCloseButton = getIsOpen(threadDetails) || isClosingCurrentConversation;
  const handleClickCloseThread = () => {
    trackEvent(getClickedModalCta({
      ctaAction: 'confirmed',
      subscreen2: 'close-thread-prompt'
    }));
    closeThread();
  };
  if (getIsSoftDeleted(threadDetails)) {
    return /*#__PURE__*/_jsxs(ButtonGroup, {
      children: [/*#__PURE__*/_jsx(ActionButton, {
        "data-test-id": "delete-thread-button",
        onClick: openDeletePrompt,
        disabled: disabled,
        icon: /*#__PURE__*/_jsx(IconHolder, Object.assign({
          icon: DeleteIcon
        }, SHARED_ICON_PROPS)),
        text: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.thread-deletion.deleteBtn"
        })
      }), /*#__PURE__*/_jsx(ActionButton, {
        "data-test-id": "restore-thread-button",
        onClick: restoreThread,
        disabled: disabled,
        icon: /*#__PURE__*/_jsx(IconHolder, Object.assign({
          icon: RotateIcon
        }, SHARED_ICON_PROPS)),
        text: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.thread-deletion.restoreBtn"
        })
      })]
    });
  } else if (shouldShowOpenButton) {
    if (isOpeningThread) {
      return /*#__PURE__*/_jsx(LoadingSpinner, {
        "data-test-id": "open-thread-loading-spinner",
        size: "extra-small",
        use: "tertiary-light"
      });
    }
    return /*#__PURE__*/_jsx(ActionButton, {
      "data-test-id": "open-thread-button",
      onClick: openThread,
      disabled: disabled,
      icon: /*#__PURE__*/_jsx(IconHolder, Object.assign({
        icon: RedoIcon
      }, SHARED_ICON_PROPS)),
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.thread-toolbar.openThreadButton"
      })
    });
  } else if (shouldShowCloseButton) {
    return /*#__PURE__*/_jsxs(ButtonGroup, {
      children: [isClosingCurrentConversation ? /*#__PURE__*/_jsx(LoadingSpinner, {
        "data-test-id": "close-conversation-loading-spinner",
        size: "extra-small",
        use: "tertiary-light"
      }) : /*#__PURE__*/_jsx(CloseConversationTourStep, {
        children: /*#__PURE__*/_jsx(ActionButton, {
          "data-test-id": "close-thread-button",
          onClick: handleClickCloseThread,
          disabled: isBotConversationWithRecentMessages(threadDetails) || disabled,
          icon: /*#__PURE__*/_jsx(IconHolder, Object.assign({
            icon: SuccessIcon
          }, SHARED_ICON_PROPS)),
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-thread-view.thread-toolbar.closeConversationBtn.closeCvText"
          })
        })
      }), getIsFiltered(threadDetails) && /*#__PURE__*/_jsx(ActionButton, {
        "data-test-id": "delete-thread-button",
        onClick: openDeletePrompt,
        disabled: disabled,
        icon: /*#__PURE__*/_jsx(IconHolder, Object.assign({
          icon: DeleteIcon
        }, SHARED_ICON_PROPS)),
        text: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.thread-deletion.deleteBtn"
        })
      })]
    });
  }
  return null;
};
ThreadPrimaryActions.displayName = 'ThreadPrimaryActions';
export default ThreadPrimaryActions;